import React, { useEffect, useState } from 'react';
import {
  Breadcrumb,
  Container,
  Alert,
} from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import DataKegiatan from './DataKegiatan';
import Poster from './Poster';
import Buttons from './Buttons';
import config from '../../../../config';

const SUPPORTED_FORMATS = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];

const FILESIZE = 10485760;

const Body = () => {
  const { idKum } = useParams();
  const today = new Date();
  const history = useHistory();
  const [state, setState] = useState({
    step: 1,
    nama_kegiatan: '',
    jenis_kegiatan: 'kuliah umum',
    tanggal: '',
    pukul: '',
    penyelenggara: '',
    nilai_kum: '',
    biaya: '',
    sertifikat: '',
    link_regis: 'https://',
    lokasi: '',
    pembicara: '',
    moderator: '',
  });
  const [alert, setAlert] = useState('');
  const [alertPoster, setAlertPoster] = useState('');

  const [poster, setPoster] = useState(null);

  const inputChange = (e, input) => {
    let ubah = e.target.value;
    if (input === 'link_regis') {
      if (ubah.length <= 8) {
        ubah = 'https://';
      } else if (!e.target.value.startsWith('https://')) {
        ubah = `https://${e.target.value}`;
      }
    }
    setState({
      ...state,
      [input]: ubah,
    });
  };

  const formik = useFormik({
    initialValues: {
      nama_kegiatan: '',
      jenis_kegiatan: 'kuliah umum',
      tanggal: '',
      pukul: '',
      penyelenggara: '',
      nilai_kum: '',
      biaya: '',
      sertifikat: '',
      link_regis: '',
      lokasi: '',
      pembicara: '',
      moderator: '',
    },
    validationSchema: Yup.object({
      nama_kegiatan: Yup.string().required('Nama Kegiatan harus diisi!'),
      jenis_kegiatan: Yup.string().required('Required!'),
      tanggal: Yup.date().min(today, 'Harus waktu di masa yang akan datang!'),
      penyelenggara: Yup.string().required('Penyelenggara harus diisi!'),
      nilai_kum: Yup.number().min(0, 'Nilai KUM tidak boleh negatif'),
      sertifikat: Yup.string().required('Keterangan sertifikat harus diisi!'),
      link_regis: Yup.string().min(9, 'Masukkan link registrasi!').required('Link Registrasi Required!'),
      lokasi: Yup.string().required('Lokasi harus diisi!'),
      pembicara: Yup.string().required('Pembicara harus diisi!'),
    }),
    onSubmit: () => {
      const formData = new FormData();
      if (!poster?.image) {
        setAlertPoster('Mohon upload poster baru');
        return;
      } if (poster) {
        const value = poster.image;
        if (!SUPPORTED_FORMATS.includes(value.type)) {
          setAlertPoster('Poster harus berupa gambar!');
          return;
        } if (value.size > FILESIZE) {
          setAlertPoster('Maksimum ukuran poster 10 MB!');
          return;
        }
      }
      formData.append('pk', idKum);
      formData.append('id', idKum);
      formData.append('nama_kegiatan', state.nama_kegiatan);
      formData.append('jenis_kegiatan', state.jenis_kegiatan);
      formData.append('tanggal', state.tanggal);
      formData.append('pukul', state.pukul);
      formData.append('penyelenggara', state.penyelenggara);
      formData.append('nilai_kum', parseFloat(state.nilai_kum).toFixed(1));
      formData.append('biaya', parseInt(state?.biaya || 0, 10));
      formData.append('sertifikat', state.sertifikat);
      formData.append('link_regis', state.link_regis);
      formData.append('lokasi', state.lokasi);
      formData.append('pembicara', state.pembicara);
      formData.append('moderator', state.moderator);
      formData.append('poster', poster.image, poster.image.name);
      axios.put(`${config.API_BASE_URL}api/kuliah_umum/`, formData, {
        headers: {
          'content-type': 'multipart/form-data',
          accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }).then(
        (response) => {
          const status = response?.data?.Status || '';
          if (status === 'Resource update succesfully') {
            history.push(`/DetailKum/${idKum}`);
          } else { setAlert(`Terdapat kesalahan ketika mengirim ke server dengan status berikut: ${status}`); }
        },
      ).catch(() => {
        setAlert('Terdapat kesalahan ketika mengirim data ke server');
      });
    },
  });

  const fetchData = () => {
    axios.get(`${config.API_BASE_URL}api/kuliah_umum/detail/${idKum}/`, {
      headers: {
        'content-type': 'multipart/form-data',
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    })
      .then((response) => {
        const status = response?.status || '';
        if (status === 200) {
          const body = response.data;
          const nilaiKumParsed = parseInt(body.nilai_kum, 10);
          const biayaParsed = parseInt(body.biaya, 10);
          setState({
            ...state,
            nama_kegiatan: body.nama_kegiatan,
            jenis_kegiatan: body.jenis_kegiatan,
            tanggal: body.tanggal,
            pukul: body.pukul,
            penyelenggara: body.penyelenggara,
            nilai_kum: nilaiKumParsed,
            biaya: biayaParsed,
            sertifikat: body.sertifikat,
            link_regis: body.link_regis,
            lokasi: body.lokasi,
            pembicara: body.pembicara,
            moderator: body.moderator,
          });
          formik.setValues({
            nama_kegiatan: body.nama_kegiatan,
            jenis_kegiatan: body.jenis_kegiatan,
            tanggal: body.tanggal,
            pukul: body.pukul,
            penyelenggara: body.penyelenggara,
            nilai_kum: nilaiKumParsed,
            biaya: biayaParsed,
            sertifikat: body.sertifikat,
            link_regis: body.link_regis,
            lokasi: body.lokasi,
            pembicara: body.pembicara,
            moderator: body.moderator,
          });
        }
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item href="/">Kuliah umum</Breadcrumb.Item>
        <Breadcrumb.Item active>{state.nama_kegiatan}</Breadcrumb.Item>
      </Breadcrumb>
      <Container>
        {alert && (
        <Alert variant="danger">
          {alert}
        </Alert>
        )}
        <DataKegiatan formik={formik} inputChange={inputChange} values={state} />
        <Poster alertPoster={alertPoster} changeFile={setPoster} />
        <Buttons onSubmit={formik.handleSubmit} />
      </Container>
    </>
  );
};

export default Body;
